import { Routes } from '@angular/router';
import { AuthGuard } from '../core/security/auth-guard.service';
import { RolesEnum } from '../core/security/roles.enum';
import { ModulesEnum } from '../core/security/modules.enum';
import { MenuGroupEnum } from '../core/security/menu-group.enum';
import { SummaryComponent } from './summary/summary.component';

export const routes: Routes = [
  {
    path: 'summary',
    component: SummaryComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SoftPhoneGroup,
      package: ModulesEnum.SoftPhoneModule,
      permissions: [RolesEnum.SoftPhoneView, RolesEnum.SoftPhoneEdit, RolesEnum.SoftPhoneDelete],
      animation: 'main',
      meta: {
        title: 'TeleGo Desktop Softphone',
        override: true,
        description: 'TeleGo Desktop Softphone Information',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'important_devices',
      },
    },
  },
];
